import Funnel from '../funnel/funnel.jsx';

const DomLoopJS = () => {
  return (
    <div style={{ textAlign: 'left' }}>
      <h1>JavaScript: DOM and Loops</h1>
      <p>All the inputs in the funnel below are now invalid and show a error validation message (e.g. First Name is Required)</p>
      <p>Using the editor on the right, write a JavaScript function that retrieves all the validation errors on screen, loops through them, and logs the validation error text to the console.</p>
      <Funnel defaultStep={1} errorState={true}/>
    </div>
  )

}

export default DomLoopJS;